import { state } from "./state";
import { detectMode, load, save, setStatus, setRerender } from "./persistence";
import { render } from "./view";
import { applyStoredCollapse } from "./collapse";
import { applyStoredPrefs } from "./prefs";
import { seed } from "../shared/random";
import { projTitle } from "./dom";
import { syncViewDialog, updateModeBtn } from "./toolbar";

// boot — module scripts are deferred, so the DOM is ready here
(async () => {
  setRerender(render); // let a coop auto-merge re-render after applying remote changes
  detectMode();
  if (!(await load())) {
    if (state.mode === "client") state.tree = seed(); // server: a fresh guid starts empty
    save();
  }
  applyStoredCollapse(state.guid || "local", state.tree); // restore this user's expand/collapse view
  applyStoredPrefs(state.guid || "local"); // restore this user's filters / columns / view mode
  projTitle.value = state.projectName;
  document.title = state.projectName.trim() || "Untitled project";
  syncViewDialog();
  updateModeBtn();
  setStatus("idle");
  render();
})();
